import {styledBox} from "../../../../themes/architecture/styled-box";

export const JackpotToastSuggestedGameBox = styledBox('JackpotToastSuggestedGameBox');